import { FontDefaults, IconDefaults, NodeDefaults } from '../consts';
import { RepresentationData } from '@ardoq/data-model';
import { truncate } from 'lodash';
import { Rect, SvgComponentRepresentation } from '@ardoq/graph';
import { createSvgElement } from '@ardoq/dom-utils';
import ReactDOMServer from 'react-dom/server';
import {
  IEdge,
  ILabel,
  ILabelOwner,
  IModelItem,
  INode,
  QueryItemToolTipEventArgs,
} from '@ardoq/yfiles';
import { escapeHTML } from '@ardoq/html';

type CreateSvgTextProps = {
  labelText: string;
  labelColor: string;
  nodeWidth: number;
};
export const createSvgText = ({
  labelText,
  labelColor,
  nodeWidth,
}: CreateSvgTextProps) => {
  const svgText = createSvgElement('text');

  // The distances from the top left of the node to the bottom left of the text
  const horizontalTextPosition =
    NodeDefaults.BORDER_RADIUS / 2 + IconDefaults.WIDTH + NodeDefaults.MARGIN;
  const verticalTextPosition = NodeDefaults.MARGIN + FontDefaults.FONT_SIZE;

  const maxTextWidth =
    nodeWidth - horizontalTextPosition - 2 * NodeDefaults.MARGIN;
  const maxTextLength = maxTextWidth / FontDefaults.FONT_WIDTH;

  const possiblyTruncatedText = truncate(labelText, { length: maxTextLength });
  const textWasTruncated = possiblyTruncatedText.length !== labelText.length;

  svgText.textContent = possiblyTruncatedText;

  if (textWasTruncated) {
    svgText.setAttribute('textLength', `${maxTextWidth}`);
  }

  svgText.setAttribute(
    'transform',
    `translate(${horizontalTextPosition}, ${verticalTextPosition})`
  );
  svgText.setAttribute('font-size', `${FontDefaults.FONT_SIZE}px`);
  svgText.setAttribute('font-family', FontDefaults.FONT_FAMILY);
  svgText.setAttribute('font-weight', `${FontDefaults.FONT_WEIGHT}`);
  svgText.setAttribute('fill', labelColor);

  return svgText;
};

export const getRepresentationElement = (
  representationData: RepresentationData
) => {
  const svgElement = createSvgElement('svg');
  const svgCompRep = ReactDOMServer.renderToStaticMarkup(
    <SvgComponentRepresentation
      representationData={representationData}
      bounds={new Rect(0, 0, IconDefaults.WIDTH, IconDefaults.HEIGHT)}
    />
  );
  svgElement.innerHTML = svgCompRep;
  return svgElement;
};

export const getTooltip = (
  eventArgs: QueryItemToolTipEventArgs<IModelItem>
) => {
  const labelOwner =
    eventArgs &&
    eventArgs.item &&
    (eventArgs.item instanceof ILabelOwner ||
      eventArgs.item instanceof ILabel) &&
    (eventArgs.item as ILabelOwner);

  if (!labelOwner) {
    return;
  }

  const item = eventArgs.item!;

  const text =
    item instanceof INode || item instanceof IEdge
      ? item.tag.text
      : item instanceof ILabel
        ? item.text
        : null;

  if (!text) return;

  eventArgs.toolTip = escapeHTML(text);
};
